import { computed, watch } from 'vue';
import { RouteLocationNormalized } from 'vue-router';
import { permissionsStateLoaded } from '~/plugins/permission';
import { usePermissionsStore } from '~/plugins/permission';

class Permission implements Middleware {
    name() {
        return 'permission';
    }

    async run(to: RouteLocationNormalized) {
        if (to.meta?.permission) {
            const permission = to.meta?.permission;

            const permissions = usePermissionsStore();
            const result = computed(() => permissions.has(permission));

            if (!(await permissionsStateLoaded(permission))) {
                watch(
                    result,
                    () => {
                        if (!result.value) {
                            if (__DEBUG__) {
                                console.error(`Permission '${permission}' required to access route '${String(to.name)}', redirecting to 404 [1]`);
                            }

                            // TODO: this should be a 403 instead
                            return {
                                name: '404',
                                params: {
                                    catchAll: location.pathname.substring(1).split('/'),
                                },
                                query: to.query,
                                hash: to.hash,
                            };
                        }
                    },
                    { once: true },
                );
            } else if (!result.value) {
                if (__DEBUG__) {
                    console.error(`Permission '${permission}' required to access route '${String(to.name)}', redirecting to 404 [2]`);
                }

                // TODO: this should be a 403 instead
                return {
                    name: '404',
                    params: {
                        catchAll: location.pathname.substring(1).split('/'),
                    },
                    query: to.query,
                    hash: to.hash,
                };
            }
        }
    }
}

export default new Permission();
